import classnames from 'classnames';
import { ReactElement, ReactNode } from 'react';
import * as React from 'react';

import { Dropdown } from './dropdownTeam';
import styles from './person.module.scss';

type PropsT = {
  children: React.ReactNode;
  className?: string;
  onActionsClick: () => void;
  previewDropdownButton: React.ReactNode;
  avatar: React.ReactNode;
  dropdown?: ReactElement | (() => ReactNode);
};

export class Person extends React.PureComponent<PropsT> {
  static displayName: string;
  render() {
    const {
      children,
      className,
      onActionsClick,
      previewDropdownButton,
      avatar,
      dropdown,
      ...otherProps
    } = this.props;

    const rootClass = classnames(
      {
        [styles.person]: true,
      },
      className,
    );
    return (
      <div {...otherProps} className={rootClass}>
        {children}
        <div className={styles.pullRight}>
          {!!avatar && <div className={styles.avatarWrap}>{avatar}</div>}
          {!!previewDropdownButton && (
            <div className={styles.previewDropdownButton}>
              {previewDropdownButton}
            </div>
          )}
          {<Dropdown>{dropdown}</Dropdown>}
        </div>
      </div>
    );
  }
}

Person.displayName = 'Person';
